import { QueryClient } from "@tanstack/react-query";

// 0016: global query defaults. staleTime 60s stops the usePagination lists (Item/List, Order/List)
// from refetching on every navigation/remount (Class B), and refetchOnWindowFocus:false stops the
// refetch on tab refocus. The 0015 bootstrap hooks set their OWN staleTime (Infinity / 5min) which
// overrides this default, so they are unaffected. Refresh-after-mutation is preserved via explicit
// refetch()/invalidateQueries on the mutating paths (refetch and invalidate ignore staleTime) — see
// addOrder (invalidates ["business-orders"]), the admin items refetch(), and agent invalidation.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
